/**
 * modalScrollLock — reference-counted background scroll lock for the canonical
 * modal system (DS2Modal).
 *
 * Nested/consecutive modals each acquire the lock; the page unlocks only when
 * the LAST one releases, and the exact prior inline styles are restored.
 * Scrollbar disappearance is compensated with body padding so locking never
 * changes layout width — a width change would fire GameScreen's grid
 * ResizeObserver and resize the Phaser stage.
 */

let lockCount = 0;
let saved: { overflow: string; paddingRight: string } | null = null;

export function acquireScrollLock(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    const body = document.body;
    saved = { overflow: body.style.overflow, paddingRight: body.style.paddingRight };
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
  }
  lockCount++;
}

export function releaseScrollLock(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) return;
  lockCount--;
  if (lockCount === 0 && saved) {
    document.body.style.overflow = saved.overflow;
    document.body.style.paddingRight = saved.paddingRight;
    saved = null;
  }
}

/** Test/diagnostic helper. */
export function isScrollLocked(): boolean {
  return lockCount > 0;
}
